import { compact, find, get, isString, isEqual, reject, toLower } from "lodash";
const findOptionByValue = _ref => {
  let {
    option,
    value,
    valueKey
  } = _ref;
  const optionValue = get(option, valueKey);
  return isString(optionValue) ?
  // Case insensitive string comparison
  toLower(value) === toLower(optionValue) :
  // Object comparison
  isEqual(value, optionValue);
};
const moveOptionToEnd = _ref2 => {
  let {
    options,
    value = "",
    valueKey = "value"
  } = _ref2;
  return compact([...reject(options, option => findOptionByValue({
    option,
    value,
    valueKey
  })), find(options, option => findOptionByValue({
    option,
    value,
    valueKey
  }))]);
};
export default moveOptionToEnd;
//# sourceMappingURL=moveOptionToEnd.js.map